import React, { useState, useEffect } from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { number } from '~/helpers';

import Card from '../Card';
import SemDados from '../SemDados';
import * as S from './styles';

function CardPerdas({ title, icon, headers, data, tooltip, style, disabled }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => (prevPage < totalPages ? prevPage + 1 : 1));
  };

  /* const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }; */

  useEffect(() => {
    setCurrentPage(1); // reset ao mudar os dados
  }, [data]);

  useEffect(() => {
    if (totalPages > 1) {
      const timer = setInterval(() => {
        setCurrentPage((prevPage) =>
          prevPage < totalPages ? prevPage + 1 : 1
        );
      }, 10000);

      return () => clearInterval(timer);
    }
  }, [totalPages]);

  const corCelulaPerda = (perda) => {
    if (perda < -0.6) {
      return '#d32f2f';
    }

    if (perda > 0.6) {
      return 'darkorange';
    }

    return 'green';
  };

  return (
    <Card
      title={title}
      icon={icon}
      tooltip={tooltip}
      disabled={disabled}
      paginacao={totalPages > 1 ? `${currentPage}/${totalPages}` : ''}
      style={style}
    >
      {data && data.length > 0 ? (
        <S.Container style={{ '--total-table-rows': currentItems.length + 1 }}>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableCell key={header}>{header}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItems.map((row, index) => (
                  <TableRow tabIndex={-1} key={`table-row-body-${index}`}>
                    <TableCell key="table-cell-body-1">
                      {row.nomeabreviadoposto}
                    </TableCell>
                    <TableCell key="table-cell-body-2">
                      {row.nomeabreviadoproduto}
                    </TableCell>
                    <TableCell
                      key="table-cell-body-3"
                      style={{
                        backgroundColor: corCelulaPerda(row.perda),
                        color: '#fff',
                        textAlign: 'center',
                        padding: 0,
                      }}
                    >
                      {`${number(row.perda, 2)}%`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </S.Container>
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardPerdas.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      idposto: PropTypes.number,
      nomeabreviadoposto: PropTypes.string.isRequired,
      idproduto: PropTypes.number,
      nomeabreviadoproduto: PropTypes.string.isRequired,
      perda: PropTypes.number.isRequired,
    })
  ).isRequired,
  tooltip: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};

CardPerdas.defaultProps = {
  style: {},
  disabled: false,
};

export default CardPerdas;
